import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useExtPersonCreateDocument = createUseMutationHook(
    'ext_person_document_create',
    personId => [
        ['ext_person_get', personId],
        'get_allowed_documents_with_ext_persons',
    ],
);
